// ─── Las tildes que la DIAN manda rotas ─────────────────────────────────────
// Los mensajes de rechazo de la DIAN llegan por Dataico con las tildes y eñes
// convertidas en «�» (U+FFFD): el texto viajó en Latin-1 y en algún punto del
// camino se leyó como UTF-8. Ese carácter ya no dice qué letra era, así que no
// se puede «decodificar»: se repara por PALABRA, con las que la DIAN usa en sus
// mensajes. Pasó con el rechazo RUT01 de MP167: «Se�or usuario… facturar
// electr�nicamente».
//
// Lo que no está en la lista se deja como llegó: adivinar una letra sería
// cambiar el mensaje de la DIAN.

const PALABRAS = [
  "señor", "señora", "contraseña", "año", "años", "compañía", "niño",
  "electrónica", "electrónicamente", "electrónico", "electrónicos", "electrónicas",
  "código", "número", "números", "régimen", "válido", "válida", "inválido", "inválida",
  "está", "están", "más", "días", "también", "después", "período", "teléfono", "país",
  "línea", "líneas", "artículo", "cálculo", "crédito", "débito", "envío", "jurídica",
  "jurídico", "único", "única", "únicamente", "último", "última", "básico", "básica",
  "razón", "según", "aún", "múltiple", "mínimo", "máximo", "público", "pública",
  "trámite", "términos", "método", "información", "validación", "identificación",
  "facturación", "dirección", "resolución", "autorización", "emisión", "expedición",
  "versión", "descripción", "operación", "obligación", "habilitación", "actualización",
  "revisión", "situación", "notificación", "transmisión", "habilitación", "verificación",
  "numeración", "relación", "condición", "retención", "nómina", "adquisición"
];

const escaparRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const conMayuscula = (s) => s.charAt(0).toUpperCase() + s.slice(1);

// Cada palabra con acento se vuelve un patrón donde cada letra no ASCII es «�».
const REPARACIONES = [...new Set(PALABRAS)]
  .flatMap(p => [p, conMayuscula(p), p.toUpperCase()])
  .filter(p => /[^\x00-\x7F]/.test(p))
  .map(p => ({ patron: new RegExp(escaparRegex(p.replace(/[^\x00-\x7F]/g, "�")).replace(/�/g, "\\uFFFD"), "g"), bien: p }))
  // Las más largas primero: «electr�nicamente» antes que «electr�nica».
  .sort((a, b) => b.bien.length - a.bien.length);

export function repararTildes(texto) {
  if (typeof texto !== "string" || !texto.includes("�")) return texto;
  let t = texto;
  for (const r of REPARACIONES) t = t.replace(r.patron, r.bien);
  // Las terminadas en -ción / -sión que no están en la lista.
  return t.replace(/([cs])i�n\b/g, "$1ión").replace(/([CS])I�N\b/g, "$1IÓN");
}
